import { Link } from "react-router-dom";
import { Shield } from "lucide-react";
import { WHATSAPP_URL, OFFICIAL_PHONE, OFFICIAL_DOMAIN } from "@/data/constants";

export default function Footer() {
  return (
    <footer style={{ backgroundColor: "#1A1A1A", color: "#FDFCF8" }}>
      {/* Fraud Warning Strip */}
      <div style={{ backgroundColor: "#B89047", padding: "14px 24px", textAlign: "center" }}>
        <p style={{ fontSize: "0.7rem", letterSpacing: "0.15em", textTransform: "uppercase", color: "#1A1A1A", fontFamily: "'Outfit', sans-serif", fontWeight: 600, margin: 0 }}>
          <Shield size={12} style={{ display: "inline", marginRight: "6px", verticalAlign: "middle" }} />
          Official domain: {OFFICIAL_DOMAIN} &nbsp;|&nbsp; Official WhatsApp: +91 {OFFICIAL_PHONE} &nbsp;|&nbsp; No agents. No third-party bookings.
        </p>
      </div>

      <div className="max-w-7xl mx-auto px-6 sm:px-10 lg:px-16 py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
          {/* Brand */}
          <div>
            <h3 style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: "1.6rem", fontWeight: 500, color: "#FDFCF8", marginBottom: "8px" }}>
              Akkshay Narula
            </h3>
            <p style={{ fontSize: "0.65rem", letterSpacing: "0.18em", color: "#B89047", textTransform: "uppercase", marginBottom: "16px", fontFamily: "'Outfit', sans-serif" }}>
              Astrologer · Numerologist · Vastu Consultant
            </p>
            <p style={{ fontSize: "0.85rem", color: "#8A8A8A", lineHeight: 1.7, fontFamily: "'Outfit', sans-serif" }}>
              Author of 4 books. Practising astrology, numerology, vastu and astrocartography with precision and purpose.
            </p>
          </div>

          {/* Navigation */}
          <div>
            <p style={{ fontSize: "0.65rem", letterSpacing: "0.18em", color: "#B89047", textTransform: "uppercase", marginBottom: "20px", fontFamily: "'Outfit', sans-serif", fontWeight: 600 }}>
              Navigate
            </p>
            <div className="flex flex-col gap-3">
              {[
                { label: "Home", path: "/" },
                { label: "Consultations & Fees", path: "/consultations" },
                { label: "Process & Policies", path: "/process" },
                { label: "Verify Authenticity", path: "/verify" },
                { label: "Contact", path: "/contact" },
              ].map((link) => (
                <Link
                  key={link.path}
                  to={link.path}
                  style={{ fontSize: "0.85rem", color: "#8A8A8A", textDecoration: "none", fontFamily: "'Outfit', sans-serif", transition: "color 0.2s" }}
                  onMouseEnter={(e) => { e.target.style.color = "#B89047"; }}
                  onMouseLeave={(e) => { e.target.style.color = "#8A8A8A"; }}
                >
                  {link.label}
                </Link>
              ))}
            </div>
          </div>

          {/* Contact */}
          <div>
            <p style={{ fontSize: "0.65rem", letterSpacing: "0.18em", color: "#B89047", textTransform: "uppercase", marginBottom: "20px", fontFamily: "'Outfit', sans-serif", fontWeight: 600 }}>
              Official Contact
            </p>
            <div className="flex flex-col gap-3">
              <p style={{ fontSize: "0.85rem", color: "#8A8A8A", fontFamily: "'Outfit', sans-serif" }}>
                WhatsApp: <span style={{ color: "#FDFCF8" }}>+91 {OFFICIAL_PHONE}</span>
              </p>
              <p style={{ fontSize: "0.85rem", color: "#8A8A8A", fontFamily: "'Outfit', sans-serif" }}>
                Domain: <span style={{ color: "#FDFCF8" }}>{OFFICIAL_DOMAIN}</span>
              </p>
              <p style={{ fontSize: "0.85rem", color: "#8A8A8A", fontFamily: "'Outfit', sans-serif" }}>
                Location: <span style={{ color: "#FDFCF8" }}>Guwahati, Assam</span>
              </p>
              <a
                href={WHATSAPP_URL}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-whatsapp-btn"
                style={{
                  display: "inline-block",
                  marginTop: "8px",
                  backgroundColor: "#B89047",
                  color: "#1A1A1A",
                  padding: "10px 20px",
                  fontSize: "0.7rem",
                  letterSpacing: "0.12em",
                  textTransform: "uppercase",
                  fontFamily: "'Outfit', sans-serif",
                  fontWeight: 600,
                  textDecoration: "none",
                  transition: "background-color 0.3s",
                }}
                onMouseEnter={(e) => { e.currentTarget.style.backgroundColor = "#9A7635"; }}
                onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = "#B89047"; }}
              >
                Request Consultation
              </a>
            </div>
          </div>
        </div>

        <div style={{ borderTop: "1px solid #2A2A2A", marginTop: "48px", paddingTop: "24px", display: "flex", justifyContent: "space-between", alignItems: "center", flexWrap: "wrap", gap: "12px" }}>
          <p style={{ fontSize: "0.75rem", color: "#4A4A4A", fontFamily: "'Outfit', sans-serif" }}>
            © {new Date().getFullYear()} Akkshay Narula. All rights reserved.
          </p>
          <p style={{ fontSize: "0.75rem", color: "#4A4A4A", fontFamily: "'Outfit', sans-serif" }}>
            Beware of fraudsters. Only trust official channels.
          </p>
        </div>
      </div>
    </footer>
  );
}
